import React, { useState, useEffect, useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { requestOrdersList, requestOrderCreate } from 'requests/sales'
import { SALES_SUBMENU } from 'constants/menu/submenus'
import { EMPTY_ORDER } from 'constants/objects/order'
import { ORDER } from 'constants/app-paths'
import { ListPage } from 'templates/ListPage'
import { SideMenu } from 'components/SideMenu'
import { ListSkeleton } from 'components/ListSkeleton'
import { OrderForm } from 'components/Sales/OrderForm'
import { Order } from './components/Order'
import { SearchForm } from './components/SearchForm'

export default function OrdersList() {
  const [showForm, setShowForm] = useState(false)
  const [orders, setOrders] = useState([])
  const [saving, setSaving] = useState(false)
  const [responseError, setResponseError] = useState()
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState()
  const [filters, setFilters] = useState()

  const history = useHistory()

  const getOrders = useCallback(async (page = 1, params = {}) => {
    const resp = await requestOrdersList(page, params)
    setLoading(false)

    if (resp.error) return

    setOrders(resp.data)
    setPagination(resp.meta?.pagination || {})
  }, [])

  useEffect(() => {
    getOrders()
  }, [getOrders])

  const onClickPagination = (page) => {
    const params = new URLSearchParams(filters)
    params.append('page', page)
    history.push({ search: params.toString() })
    getOrders(page, filters)
  }

  const onSearch = (params) => {
    setFilters(params)
    const query = new URLSearchParams(params)
    history.push({ search: query.toString() })
    getOrders(1, params)
  }

  const onToggleForm = () => {
    setShowForm(!showForm)
  }

  const onSelectOrder = (id) => {
    const path = generatePath(ORDER, { id })
    history.push(path)
  }

  const onSaveOrder = async (params) => {
    setSaving(true)
    const response = await requestOrderCreate(params)

    setSaving(false)
    if (response.error) return setResponseError(response)

    return onSelectOrder(response.data.id)
  }

  const renderSearchForm = () => (
    <SearchForm onSearch={onSearch} />
  )

  const renderForm = () => (
    <OrderForm
      onCancel={onToggleForm}
      order={EMPTY_ORDER}
      onSave={onSaveOrder}
      saving={saving}
      responseError={responseError}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={SALES_SUBMENU} />
  )

  const renderOrder = (order) => (
    <Order
      order={order}
      key={order.id}
      onClick={onSelectOrder}
    />
  )

  const renderList = () => {
    if (loading) return <ListSkeleton />

    if (!orders.length) {
      return (
        <div>Nenhum pedido encontrado</div>
      )
    }

    return orders.map(renderOrder)
  }

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Lista de pedidos"
      onClickPagination={onClickPagination}
      pagination={pagination}
      loading={loading}
      showForm={showForm}
      onToggleForm={onToggleForm}
      showAddButton
      renderSearchForm={renderSearchForm}
      openSearchForm
    >
      { renderList() }
    </ListPage>
  )
}
